module.exports = __webpack_public_path__ + "static/img/blog_good_8.712d8c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_8.png
// module id = huLW
// module chunks = 8